import { useEffect, useState } from 'react';
import { searchService } from '../services/search';
import { useTenantConfig } from '../contexts';
import { NewsFeedEntity } from 'types';
import { useLoading } from '@teko/ds-desktop';

export const useNewsFeed = ({
  ssrNews,
  ssrTotalItems = 0,
  page = 1,
  feedId,
}: {
  ssrNews?: NewsFeedEntity[];
  ssrTotalItems?: number;
  page?: number;
  feedId?: string;
}) => {
  const [news, setNews] = useState(ssrNews);
  const [totalItems, setTotalItems] = useState(ssrTotalItems);
  const [loading, setLoading] = useLoading('useNewsFeed');
  const { terminal } = useTenantConfig();

  useEffect(() => {
    setLoading(true);
    searchService
      .getNewsFeed(terminal, feedId, page)
      .then(({ news: _news, totalItems: _total }) => {
        setNews(_news);
        setTotalItems(_total);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page]);

  return {
    news,
    totalItems,
    loading,
  };
};
